import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

export interface NetworkOfflineModalState {
  open: boolean;
  title: string;
  message: string;
  retryLabel: string;
}

const DEFAULT_STATE: NetworkOfflineModalState = {
  open: false,
  title: 'Sin conexión',
  message: 'No pudimos conectarnos. Revisa tu internet e inténtalo nuevamente.',
  retryLabel: 'Reintentar',
};

@Injectable({ providedIn: 'root' })
export class NetworkOfflineModalService {
  private readonly stateSubject = new BehaviorSubject<NetworkOfflineModalState>(DEFAULT_STATE);
  private readonly retrySubject = new Subject<void>();

  readonly state$: Observable<NetworkOfflineModalState> = this.stateSubject.asObservable();
  readonly retry$: Observable<void> = this.retrySubject.asObservable();

  show(patch?: Partial<Omit<NetworkOfflineModalState, 'open'>>): void {
    const current = this.stateSubject.getValue();
    this.stateSubject.next({
      ...current,
      ...patch,
      open: true,
    });
  }

  close(): void {
    const current = this.stateSubject.getValue();
    if (!current.open) return;
    this.stateSubject.next({
      ...current,
      open: false,
    });
  }

  emitRetry(): void {
    this.retrySubject.next();
  }
}

